import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TagComponent } from "@merchant-webapp/components";
import { TranslocoPipe } from "@jsverse/transloco";
import { NgForOf } from "@angular/common";

@Component({
  selector: "er-block-view-card",
  templateUrl: "./block-view-card.conponent.html",
  imports: [TagComponent, TranslocoPipe, TagComponent, NgForOf],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BlockViewCardComponent {
  @Input()
  public title!: string;

  @Input()
  public data!: string | number | undefined;

  @Input()
  public hasHr: boolean = true;
}
